import EditableText from "../ui/EditableText"

const defaultParagraphs = [
  "Dr. Dirk Dantz is a European Patent Attorney with extensive experience in intellectual property, technology and industry.",
  "His professional background includes many years in C-level and senior IP positions within industrial companies. This experience enables him to combine legal and technical IP expertise with a clear understanding of business models, competitive environments and commercial objectives.",
  "His work focuses on strategic IP advice and the development and implementation of IP strategies tailored to the individual objectives of each client.",
  "Dr. Dantz also has extensive experience in the valuation and licensing of IP portfolios, with a track record in the nine-figure EUR range, as well as in negotiating and drafting cooperation and technology-related agreements.",
]

const defaultCredentialLines = [
  "Dr. rer. nat. Dipl.-Min.",
  "European Patent Attorney",
  "info@xpress-ip.com",
]

interface FounderSectionProps {
  name?: string
  role?: string
  paragraphs?: string[]
  photoName?: string
  credentialLines?: string[]
  editable?: boolean
  onSaveName?: (value: string) => void
  onSaveRole?: (value: string) => void
  onSaveParagraph?: (index: number, value: string) => void
  onSavePhotoName?: (value: string) => void
  onSaveCredentialLine?: (index: number, value: string) => void
}

export default function FounderSection({
  name = "DR. DIRK DANTZ",
  role = "Founder and owner",
  paragraphs = defaultParagraphs,
  photoName = "DR. DIRK DANTZ",
  credentialLines = defaultCredentialLines,
  editable = false,
  onSaveName,
  onSaveRole,
  onSaveParagraph,
  onSavePhotoName,
  onSaveCredentialLine,
}: FounderSectionProps) {
  return (
    <section className="bg-white px-4 pt-10 md:px-8">
      <div className="relative mx-auto max-w-6xl pt-10">
        <div className="absolute left-0 right-0 top-0">
          <div className="h-px w-full bg-dantzBlue" />
          <div className="absolute left-0 top-0 h-4 w-px bg-dantzBlue" />
          <div
            className="absolute top-0 hidden h-4 w-px bg-dantzBlue md:block"
            style={{ right: "calc(300px + 3rem)" }}
          />
          <div className="absolute right-0 top-0 h-4 w-px bg-dantzBlue" />
        </div>

        <div className="grid grid-cols-1 gap-12 md:grid-cols-[1fr_300px]">
          <div className="text-dantzBlue">
            <EditableText
              as="h2"
              value={name}
              editMode={editable}
              onSave={(value) => onSaveName?.(value)}
              className="text-[24px] font-normal tracking-wide"
            />

            <EditableText
              as="p"
              value={role}
              editMode={editable}
              onSave={(value) => onSaveRole?.(value)}
              className="mt-6 font-semibold"
            />

            <div className="mt-2 flex flex-col gap-6 text-justify text-sm leading-relaxed">
              {paragraphs.map((paragraph, index) => (
                <EditableText
                  key={index}
                  as="p"
                  value={paragraph}
                  editMode={editable}
                  multiline
                  onSave={(value) => onSaveParagraph?.(index, value)}
                />
              ))}
            </div>
          </div>

          <figure className="md:mt-8">
            <div className="aspect-[4/3] w-full bg-slate-200 md:aspect-auto md:h-[220px]">
              <img
                src="/images/dirk-dantz.jpg"
                alt="Dr. Dirk Dantz"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <figcaption className="bg-dantzBlue px-4 py-6 text-center text-white">
              <EditableText
                as="span"
                value={photoName}
                editMode={editable}
                onSave={(value) => onSavePhotoName?.(value)}
                className="block text-lg tracking-wide"
              />
              <div className="mt-1 flex flex-col text-sm font-light leading-relaxed">
                {credentialLines.map((line, index) => (
                  <EditableText
                    key={index}
                    as="span"
                    value={line}
                    editMode={editable}
                    onSave={(value) => onSaveCredentialLine?.(index, value)}
                  />
                ))}
              </div>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  )
}
